import Box from '@mui/material/Box';
import { palette } from '../theme/palette';

const Styles = {
  wrapper: {
    width: '110px',
    height: '30px',
    borderRadius: 50,
    padding: '4px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    transition: '200ms all',
    position: 'relative',
  },
  thumb: {
    width: 22,
    height: 22,
    borderRadius: 50,
  },
};

const CustomSwitch = ({
  checked,
  disabled,
  onChange,
}: {
  checked: boolean;
  disabled?: boolean;
  onChange: () => void;
}) => {

  return (
    <Box
      sx={[
        Styles.wrapper,
        {
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.5 : 1,
        },
        {
          ...(checked
            ? {
                backgroundColor: palette.success.dark,
                border: `1px solid ${palette.success.dark}`,
                justifyContent: 'flex-end',
                '&::after': {
                  content: '"Enabled"',
                  color: palette.primary.contrastText,
                  position: 'absolute',
                  left: 12,
                },
              }
            : {
                backgroundColor: palette.primary.contrastText,
                border: `1px solid ${palette.secondary.dark}`,
                justifyContent: 'flex-start',
                '&::before': { content: '"Disabled"', color: palette.secondary.dark, position: 'absolute', left: 30 },
              }),
        },
      ]}
      onClick={() => {
        if (disabled) return;
        onChange();
      }}
    >
      <Box
        component='span'
        sx={[
          Styles.thumb,
          {
            backgroundColor: checked ? palette.primary.contrastText : palette.secondary.dark,
          },
        ]}
      ></Box>
    </Box>
  );
};

export default CustomSwitch;
